---
fr:
  add_company: Ajouter une entreprise
  add_parent_company: Ajouter une société mère
  cancel: Annuler
  companies:
    community_access_locked: Les publications de la communauté sont désactivées par la société mère
    delete_company: Supprimer l'entreprise
    errors:
      missing_company: L'entreprise doit être présente pour l'arborescence.
  delete: Supprimer
  edit: Modifier
  external_URLs: URLs externes
  kiosk_mode_setup: Configuration du mode kiosque
  name: Nom
  ownership_share: Part de propriété
  ownership_share_saves_on_exit: Enregistré à la sortie
  ownership_share_unlock: Déverrouiller pour modifier la part de propriété. Elle est enregistrée dès que vous quittez le champ.
  parent_companies: Sociétés mères
  parent_company_last_parent_locked: Impossible de supprimer la dernière société mère. Pour en faire une société de niveau supérieur, contactez le support.
  parent_company_locked: Verrouillé
  portal_config: Configuration du portail
  save: Enregistrer
  select_parent_company: Sélectionner la société mère
  subsidiaries: Filiales
